module.exports = __webpack_public_path__ + "img/art-30.297cf36c.png";